import React from 'react';
import Typography from '@material-ui/core/Typography';
import logo from "../../assets/logo.png";
import styles from './Navbar.module.css'
import Button from '@material-ui/core/Button';
import {Link} from "react-router-dom";


export default function Header({notHomePage,HomePage}) {

  return (
    <div className={styles.component}>
        <a href="https://www.vitrendz.tech" target="_self" className={styles.link}>
          <Typography noWrap>
            <img src={logo} className={styles.navbarLeft} alt="Company Logo"></img>
          </Typography>
          </a>
          <div className={styles.navbarRight}>

          {HomePage ? ( 
            
              <a href="https://www.covid19india.org/" style={{textDecoration:"none"}}>
                <Button
                  variant="contained"
                  size="small"
                  endIcon={<i className="far fa-chart-bar" />}
                  className={styles.statsButton}
                >
                    Covid Stats
                </Button> </a>) : (
                
              <Link to='/' className={styles.link}>
                <Button
                  variant="contained"
                  size="small"
                  color="primary"
                  endIcon={<i className="fas fa-home" />}
                  className={styles.homeButton}
                >
                      Home Page
                </Button>
              </Link> ) 
          }

          </div>
    </div>
  );
}